import { render, staticRenderFns } from "./downloadMan.vue?vue&type=template&id=640407ca&scoped=true&"
import script from "./downloadMan.vue?vue&type=script&lang=js&"
export * from "./downloadMan.vue?vue&type=script&lang=js&"
import style0 from "./downloadMan.vue?vue&type=style&index=0&id=640407ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640407ca",
  null
  
)

export default component.exports